import axios from 'axios'

const HTML_ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', '\'': '&#39;' }

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, character => HTML_ESCAPES[character])
}

function withArticle(noun) {
  return (/^[aeiou]/i.test(noun) ? 'An ' : 'A ') + noun
}

function isDuplicateRecordError(err) {
  return !!(err && err.response && err.response.status === 409 && err.response.data && err.response.data.duplicate)
}

/**
 * POSTs a new record. When the API reports that a record with a matching name already exists, the user
 * chooses between creating another one anyway and using the existing one. Choosing the existing one
 * resolves with it in the same response shape as a successful create, so callers need no changes.
 */
export default function createRecordConfirmingDuplicates(dispatch, { url, data, label }) {
  return axios({ method: 'post', url, data })
    .catch(err => {
      if (!isDuplicateRecordError(err)) {
        throw err
      }

      const existing = err.response.data.duplicate
      const name = escapeHtml(existing.name || existing.title || '')
      const message = `${withArticle(label)} named <strong>${name}</strong> already exists. ` +
        'Confirm to create another one anyway, or choose Nevermind to use the existing one.'

      return dispatch('confirm', message)
        .then(createAnyway => createAnyway
          ? axios({ method: 'post', url, data: Object.assign({}, data, { allow_duplicate: true }) })
          : { data: { data: existing } })
    })
}
